module.exports = __webpack_public_path__ + "img/image46.1f86eefb.webp";